import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export default async function getUtteranceFlagCount(category, clientKey, userKey) {
  validateUserKey(userKey);
  try {
    const { data } = await apiClient.get("api/getUtteranceFlagCount", {
      params: { category, clientkey: clientKey, userKey },
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
